export const staticData = [
  {
    name: 'Redan',
    image: '/assets/images/sip/success-stories/redan.png',
    descriptn:
      'After 8-month-old Redan was diagnosed with heart disease, his parents struggled to find the money needed to save his life. But thanks to our donors, Redan was able to successfully survive heart disease with an open-heart surgery.',
    raised: 'Raised ₹2,40,000 for Surgery',
  },
  {
    name: 'Anthony',
    image: '/assets/images/sip/success-stories/anthony.png',
    descriptn:
      'When 1-year-old Anthony was diagnosed with liver disease, his mother, a housekeeper prayed for a miracle. She knew she could not afford treatment. Thankfully, our donors were able to step in to fund his transplant & save Anthony\'s life!',
    raised: 'Raised ₹16,50,000 for a Transplant',
  },
  {
    name: 'Balu',
    image: '/assets/images/sip/success-stories/balu.png',
    descriptn:
      '5-year-old Balu needed chemotherapy & blood transfusions in order to survive cancer. But as daily wagers, his parents could not afford this. Thanks to the efforts of our donors, Balu was able to recieve treatment. He is now happy & healthy!',
    raised: 'Raised ₹15,00,000 for Chemotherapy',
  },
  {
    name: 'Aashiya',
    image: '/assets/images/sip/success-stories/aashiya.png',
    descriptn:
      '4-year-old Aashiya suffered hearing loss very early on & thought she would never hear. With the help of our donors, she was able to receieve a cochlear implant. On hearing her very first sounds, Aashiya cried tears of joy.',
    raised: 'Raised ₹8,00,000 for an Implant',
  },
  {
    name: 'Sai shree',
    image: '/assets/images/sip/success-stories/sai-shree.png',
    descriptn:
      'When 1-year-old Sai Shree was diagnosed with cancer, her parents felt helpless. Her father had just lost his job. They worried they would lose her - until our donors stepped up. Sai Shree then recieved treatment & is well on her way to beating cancer',
    raised: 'Raised ₹15,00,000 for Chemotherapy',
  },
];
